import { render } from "./SignAndSubmitModal.vue?vue&type=template&id=5fff0f01&ts=true"
import script from "./SignAndSubmitModal.vue?vue&type=script&lang=ts"
export * from "./SignAndSubmitModal.vue?vue&type=script&lang=ts"

import "./SignAndSubmitModal.vue?vue&type=style&index=0&id=5fff0f01&lang=css"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__